export const API_KEY = 'AIzaSyA-ZgWzG8XfDJ_xfkoq1pU_tt4l6CHGiWQ'
